import CustomPopup from './CustomPopup';

export default CustomPopup;